import request from '@/utils/request'

/**
 * 获取广告栏配置
 */
export const getAdBannerConfig = () => {
  return request({
    url: '/admin/ad-banner',
    method: 'GET'
  })
}

/**
 * 更新广告栏配置
 */
export const updateAdBannerConfig = (data) => {
  return request({
    url: '/admin/ad-banner',
    method: 'PUT',
    data
  })
}
